import React from 'react';
import { motion } from 'framer-motion';
import { Coins, Heart, Home, Brain, Users, ArrowRight } from 'lucide-react';
export function BridgesSection() {
  const dimensions = [{
    icon: <Coins data-id="element-30" />,
    name: 'Finances & Future',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    icon: <Heart data-id="element-31" />,
    name: 'Health & Well-being',
    color: 'bg-rose-100 text-rose-700'
  }, {
    icon: <Home data-id="element-32" />,
    name: 'Housing & Community',
    color: 'bg-blue-100 text-blue-700'
  }, {
    icon: <Brain data-id="element-33" />,
    name: 'Mindset & Purpose',
    color: 'bg-purple-100 text-purple-700'
  }, {
    icon: <Users data-id="element-34" />,
    name: 'Connection & Legacy',
    color: 'bg-amber-100 text-amber-700'
  }];
  return <section id="ecosystem" className="py-24 bg-white" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-38">
            <h2 className="text-teal-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-39">
              The Ecosystem
            </h2>
            <h3 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-40">
              Bridges of Life
            </h3>
            <p className="text-xl text-gray-600 mb-6" data-id="element-41">
              A family of products designed to unlock human potential across
              life stages.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-42">
              Bridges of Life creates guided conversations that reveal insights,
              align people, and generate clarity—turning uncertainty into
              structured action. It's the entry point to understanding where you
              are and where you need to go.
            </p>
            <button className="flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-43">
              Experience Bridges of Life
              <ArrowRight size={18} data-id="element-44" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-45">
            {dimensions.map((dim, idx) => <div key={idx} className={`p-6 rounded-xl border border-gray-100 shadow-sm flex flex-col items-start gap-4 ${idx === 4 ? 'sm:col-span-2 sm:flex-row sm:items-center' : ''}`} data-id="element-46">
                <div className={`p-3 rounded-lg ${dim.color}`} data-id="element-47">{dim.icon}</div>
                <span className="font-semibold text-gray-900" data-id="element-48">{dim.name}</span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}